import React from "react";
import { OverlayTrigger, Spinner, Table, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { parseAndLinkify } from "@/components/Utils";
import VkVideoStatus from "@components/Common/VKVideo/VKVideoStatus";
import { DevForm } from "@components/Forms/Fields";
import { Awesome } from "@components/Helpers";
import ListItemImage from "@screens/Game/Highlights/components/ListItemImage";
import TypeBadge from "@screens/Game/Highlights/components/TypeBadge";

const TooltipWrapper = ({ apiData, item, children }) => {
    const tooltipText = apiData?.hl_data?.draft_lock_state[item.state];
    return (
        <>
            {tooltipText ? (
                <OverlayTrigger overlay={<Tooltip>{tooltipText}</Tooltip>}>
                    <span>{children}</span>
                </OverlayTrigger>
            ) : (
                { children }
            )}
        </>
    );
};

const DraftLockState = (props) => {
    if (props.item.state === "new") {
        return (
            <TooltipWrapper {...props}>
                <Awesome type="unlock" />
            </TooltipWrapper>
        );
    }

    if (props.item.state === "lock") {
        return (
            <TooltipWrapper {...props}>
                <Awesome type="lock" />
            </TooltipWrapper>
        );
    }

    if (props.item.state === "refused") {
        return (
            <TooltipWrapper {...props}>
                <Awesome type="thumbs-down" />
            </TooltipWrapper>
        );
    }

    if (props.item.state === "accepted") {
        return (
            <TooltipWrapper {...props}>
                <Awesome type="thumbs-up" />
            </TooltipWrapper>
        );
    }

    return props.item.state;
};

function ListDraft({ idsToDelete, deleteToggleHandle, apiData, isLoading, locl }) {
    const { t } = useTranslation();

    const hlDraftObjects = apiData?.hl_data?.object_list_draft ? apiData.hl_data.object_list_draft[locl] : undefined;
    if (isLoading === true) {
        return (
            <div className="d-flex align-items-center justify-content-center">
                <Spinner animation="border" variant="primary" role="status" />
            </div>
        );
    }

    return (
        <Table>
            <thead>
                <tr>
                    <th width="5%" />
                    <th width="20%">{t("Изображение")}</th>
                    <th width="15%">{t("Тип")}</th>
                    <th width="60%">{t("Комментарий модератора")}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {hlDraftObjects &&
                    hlDraftObjects.map((item) => (
                        <tr key={`draft-${item.id}`}>
                            <td>
                                <DraftLockState apiData={apiData} item={item} />
                            </td>
                            <td>
                                <ListItemImage data={item.draft_object} />
                            </td>
                            <td>
                                <TypeBadge data={item.draft_object} />
                                <br />
                                <VkVideoStatus data={item.draft_object.vkvideo_data} />
                            </td>
                            <td className="show-wrap-text">{parseAndLinkify(item.comment)}</td>
                            <td className="text-right">
                                {item.state !== "lock" && (
                                    <DevForm.Checkbox
                                        checked={idsToDelete.includes(item.id)}
                                        value={item.id}
                                        onChange={(e) => deleteToggleHandle(e, true)}
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
            </tbody>
        </Table>
    );
}

export default ListDraft;
